import { memo } from 'react';

import { Filters } from '@air/next-icons';
import { useBreakpointsContext } from '@air/provider-media-query';

export type FiltersDropdownHeaderProps = {
  title: string;
};

export const FiltersDropdownHeader = memo(({ title }: FiltersDropdownHeaderProps) => {
  const { isAboveMediumScreen } = useBreakpointsContext();

  if (isAboveMediumScreen) {
    return (
      <header
        className="flex h-9 items-center border-b border-b-grey-5 px-3 font-bold text-10 text-grey-10 uppercase tracking-wider"
        data-testid="FILTERS_DROPDOWN_TITLE"
      >
        {title}
      </header>
    );
  }

  return (
    <header
      className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b border-b-grey-4 bg-grey-1 px-4"
      data-testid="FILTERS_DROPDOWN_TITLE"
    >
      <div className="flex size-10 items-center justify-center">
        <Filters className="size-6 text-grey-10" />
      </div>
      <span className="font-medium text-18 text-grey-12">Filters</span>
    </header>
  );
});

FiltersDropdownHeader.displayName = 'FiltersDropdownHeader';
